import { ALL_TEST_KITS } from './catalog';
/**
 * Look up the ideal range for a normalized parameter key.
 *
 * Searches the test-kit catalog for the first kit with that parameterKey
 * that also has an `idealRange` defined, and returns it. Returns `null`
 * if no kit in the catalog defines a range for this parameter.
 */
export function getIdealRangeForParameter(parameterKey) {
    for (const kit of ALL_TEST_KITS) {
        if (kit.parameterKey === parameterKey && kit.idealRange) {
            return { min: kit.idealRange.min, max: kit.idealRange.max };
        }
    }
    return null;
}
/**
 * Classify a test result relative to the ideal range for its parameter.
 *
 * Returns one of four string-literal values — UI maps these to colors.
 */
export function classifyResult(parameterKey, result) {
    if (typeof result !== 'number')
        return 'unknown';
    const range = getIdealRangeForParameter(parameterKey);
    if (!range)
        return 'unknown';
    if (result < range.min)
        return 'low';
    if (result > range.max)
        return 'high';
    return 'ideal';
}
//# sourceMappingURL=ideal-ranges.js.map